import { render, staticRenderFns } from "./BenefitsTable.vue?vue&type=template&id=442b8b76&scoped=true&lang=pug&"
import script from "./BenefitsTable.vue?vue&type=script&lang=js&"
export * from "./BenefitsTable.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsTable.vue?vue&type=style&index=0&id=442b8b76&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b8b76",
  null
  
)

export default component.exports